import { useReadUnreadPersons } from "./model/use-read-unread-persons";
import {
  CompanyDocumentAnalyticsRecordFragment,
  PersonConfirmationFilter,
} from "gql/graphql";
import { MetaFilter } from "@/shared/filters-by-meta";
import { FC, useState } from "react";
import { CompanyDocumentAnalyticsOptionsProps } from "@/modules/documents/widgets/company-document-analytics-options";
import { CompanyDocumentAnalyticsView } from "@/modules/documents/widgets/company-document-statistic/ui/company-document-analytics-view";
import { InSidebar } from "@/shared/portal";
import { SelectedParticipant } from "./ui/selected-participant";

export function CompanyDocumentAnalytics({
  id,
  Options,
}: {
  id: string;
  Options: FC<CompanyDocumentAnalyticsOptionsProps>;
}) {
  const { filter } = MetaFilter.useFilter<PersonConfirmationFilter>();
  const { loading, records, pagination, readConfirmationType } =
    useReadUnreadPersons({
      id,
      filter,
    });
  const [selected, setSelected] =
    useState<CompanyDocumentAnalyticsRecordFragment>();

  return (
    <>
      <CompanyDocumentAnalyticsView
        dataSource={records}
        loading={loading}
        pagination={pagination}
        Options={Options}
        readConfirmationType={readConfirmationType}
        selectedId={selected?.id}
        onSelect={(record) =>
          setSelected((current) =>
            current?.id === record.id ? undefined : record,
          )
        }
      />

      <InSidebar condition={!!selected}>
        {selected && (
          <SelectedParticipant
            record={selected}
            readConfirmationType={readConfirmationType}
            onClose={() => setSelected(undefined)}
          />
        )}
      </InSidebar>
    </>
  );
}
